module.exports = __webpack_public_path__ + "img/noSetted.6db3f9ae.svg";